// extracted by mini-css-extract-plugin
export var content = "_ba-3";
export var list = "_ba-4";
export var settingsContent = "_ba-7";
export var settingsPanel = "_ba-8";
export var state = "_ba-6";
export var triggerBadge = "_ba-2";
export var triggerButton = "_ba-1";
export var triggerShell = "_ba-0";
export var unreadDot = "_ba-5";